module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 16
// module chunks = 0